import { graphql } from 'gql'

export const UPDATE_DOMAIN_K_WORDS = graphql(`
  mutation updateDomainKWords($input: UpdateDomainRichPlacementKwordsConfigurationInput!) {
    updateDomainRichPlacementKwordsConfiguration(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
